const userAgent = navigator.userAgent.toLowerCase();

export const isAndroid = userAgent.indexOf('android') > -1;
export const isIOS = userAgent.match(/iphone|ipad|ipod/);
